import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
let expandedRowKeys = [];
const rowSelection = {
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
    expandedRowKeys = selectedRows;
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    expandedRowKeys = selectedRows;
  }
};
import classificationModel from './classificationModel.vue';
import { claimsTypeList, delClaimsType, claimsTypeStatus } from './request';
export default {
  components: {
    classificationModel
  },
  data() {
    return {
      expandedRowKeys,
      rowSelection,
      form: {},
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'index'
        },
        width: 80
      }, {
        slots: {
          title: '分类名称'
        },
        dataIndex: 'name',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '排序'
        },
        dataIndex: 'sort',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '状态'
        },
        dataIndex: 'status',
        key: '3',
        align: 'center',
        scopedSlots: {
          customRender: 'status'
        },
        width: 150
      }, {
        slots: {
          title: '更新时间'
        },
        dataIndex: 'updateAt',
        key: '4',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'sort',
        key: '5',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 200
      }],
      classificationShow: false
    };
  },
  created() {
    this.getDataFun();
  },
  methods: {
    getDataFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      claimsTypeList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleAdd() {
      this.classificationShow = true;
      this.$nextTick(() => {
        this.$refs.classificationFrom.init();
      });
    },
    handleEdit(val) {
      this.classificationShow = true;
      this.$nextTick(() => {
        this.$refs.classificationFrom.init(val, true);
      });
    },
    handleDelete(val) {
      let _this = this;
      this.$alert(this.$t('是否确认删除该分类？'), {
        confirmButtonText: this.$t('确定')
      }).then(() => {
        delClaimsType({
          claimsSortId: [val.id]
        }).then(res => {
          _this.$message.success(this.$t('删除成功'));
          _this.getDataFun();
        });
      });
    },
    handleDel() {
      if (expandedRowKeys.length == 0) {
        this.$message.error(this.$t('请选择要删除的数据'));
        return false;
      }
      let arr = [];
      expandedRowKeys.map(item => {
        arr.push(item.id);
      });
      delClaimsType({
        claimsSortId: arr
      }).then(res => {
        expandedRowKeys = [];
        this.$message.success(this.$t('删除成功'));
        this.getDataFun();
      });
    },
    checkedFun(val) {
      if (!this.isAuth('home.claimsSortStatus')) {
        this.$message.error(this.$t('暂无权限'));
        return false;
      }
      claimsTypeStatus({
        claimsSortId: val.id,
        status: val.status == 1 ? 0 : 1
      }).then(res => {
        this.$message.success(this.$t('修改成功'));
        this.getDataFun();
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    }
  }
};